import * as constants from '../constants'

const firstState = () => ({
  isBasketModal: false,
  basketItems: []
})

const getters = {
  totalBasketItems: state => state.basketItems
    .map(item => item.quantity)
    .reduce((sum, current) => sum + current, 0),

  totalPrice: state => state.basketItems
    .map(item => item.price * item.quantity)
    .reduce((sum, current) => sum + current, 0)
}

const mutations = {

  [constants.FETCH_BASKET_FROM_LOCAL](state, payload) {
    state.basketItems = payload
  },
  [constants.SAVE_TO_LOCAL](state, payload) {
    state.basketItems.push(Object.assign({}, payload))
    localStorage.setItem('basket_items', JSON.stringify(state.basketItems))
  },
  [constants.DELETE_FROM_LOCAL](state, payload) {
    state.basketItems.splice(payload, 1)
    localStorage.setItem('basket_items', JSON.stringify(state.basketItems))
  },
  [constants.CLEAR_BASKET](state,) {
    state.basketItems = []
    localStorage.setItem('basket_items', JSON.stringify(state.basketItems))
  }
}

const actions = {
  fetchBasketFromLocal({ commit }) {
    let localBasket = localStorage.getItem('basket_items')
    if (localBasket) {
      localBasket = JSON.parse(localStorage.getItem('basket_items'))
      commit(constants.FETCH_BASKET_FROM_LOCAL, localBasket)
    }
  },
  pushToCart({ commit }, payload) {
    commit(constants.SAVE_TO_LOCAL, payload)
  },
  deleteFromCart({ commit }, payload) {
    commit(constants.DELETE_FROM_LOCAL, payload)
  },
  clearBasket({ commit }, payload) {
    commit(constants.CLEAR_BASKET, payload)
  }
}

export default {
  state: firstState,
  getters,
  mutations,
  actions
}
